<template>
  <account-signup platform="portal" :entityLevel="entityLevel" :entityName="entityName" />
</template>

<script>
import AccountSignUp from '../../components/assemble-account/AccountSignUp.vue';

export default {
  name: 'SignUp',
  components: {
    'account-signup': AccountSignUp
  },
  props: {
    entityLevel: String,
    entityName: String,
  }
};
</script>

<style scoped lang="scss">
</style>
